<template minapp="mpx" xlang="wxml">
  <view class="recommend-drawer">
    <view class="info">
      <view class="left">
        <view class="tag">{{ recommendCardInfo.tag }}</view>
        {{ recommendCardInfo.info }}
      </view>
      <view>{{ recommendCardInfo.seat }}</view>
    </view>
    <more-less-guide guide="{{recommendCardInfo.guide}}" />
    <view class="tips">
      <view wx:if="{{makeOrder}}" class="tips-order">
        温馨提示：
        <hl-text
          class="tips-order-text"
          text="{{ recommendCardInfo.orderTips }}"
          hlColor="{{recommendCardInfo.highlight}}"
        />
      </view>
      <hl-text
        wx:else
        class="tips-text"
        text="{{ recommendCardInfo.tips }}"
        hlColor="{{recommendCardInfo.highlight}}"
      />
    </view>
    <view wx:if="{{showWarning}}" class="warning" bindtap="goWarning">利用”买短乘长“恶意逃票属违法行为，情节严重的将被追究刑事责任</view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { goTo } from '@didi/webx-js'

  createComponent({
    props: {
      show: {
        type: Boolean,
        value: false
      },
      makeOrder: {
        type: Boolean,
        value: false
      }
    },
    data: {},
    computed: {
      ...store.mapState({
        recommendCardInfo: 'train.recommendCardInfo'
      }),
      showWarning() {
        return this.makeOrder && this.recommendCardInfo.guide.type == 3
      }
    },
    methods: {
      goWarning() {
        goTo({url: 'https://v.didi.cn/dW8eLQl'})
      }
    }
  })
</script>

<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'

  .recommend-drawer
    padding 21px 16px 10px
    font-family PingFang SC
    font-size 14px
    font-weight 500
    color #222222
    background #FFFFFF
  .info
    display flex
    align-items center
    justify-content space-between
    width 100%
    margin-bottom 14px
  .left
    display flex
    align-items center
  .tag
    background #338FFF
    margin-right 8px
    border-radius 4px
    color #FFFFFF
    font-size 12px
    width 58px
    height 18px
    line-height 18px
    text-align center
  .tips
    font-size 12px
    background #F2F6F9
    border-radius 6px
    margin-top 20px
    height 32px
    line-height 32px
    vertical-align middle
    //文字前空格
    padding-left 12px
    &-text
      color #222222
      font-weight 400
      line-height 32px
      vertical-align middle
    &-order
      font-weight 500
      display flex
      align-items center
      &-text
        margin-top -1px
        color #222222
        font-weight 400
  .warning
    font-size 10px
    color #999999
    margin-top 8px
    margin-bottom -2px
    position relative
    &::after
      position absolute
      content ''
      width 4px
      height 4px
      border-top 1px solid
      border-right 1px solid
      position absolute
      top 5px
      right 2px
      transform rotate(45deg)
  .pay-container
    height 100px
    padding 11px 14px 0 16px
    box-shadow inset 0px 1px 0px 0px #EEEEEE
    border-radius 10px 10px 0px 0px
    display flex
    justify-content space-between
    align-items baseline
  .price
    color #FF6400
    font-size 32px
    font-weight 500
    display flex
    align-items baseline
    &-symbol
      font-size 16px
      font-weight normal
  .btn
    width 140px
    height 50px
    background #FF6400
    color #FFFFFF
    font-size 16px
    font-weight 500
    display flex
    align-items center
    justify-content center
    border-radius 10px
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'controllable-drawer-bottom': '@/components/controllable-drawer-buttom',
      'more-less-guide': './more-less-guide',
      'hl-text': '@/components/hl-text'
    }
  }
</script>